import React, { useState, useEffect, useRef, useCallback } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import AgentXLauncher from '../agentx/AgentXLauncher';

const AppShell = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const touchStart = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Swipe right to open, swipe left to close (mobile)
  const handleTouchStart = useCallback((e) => {
    touchStart.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback((e) => {
    if (!touchStart.current || !isMobile) return;
    const diff = e.changedTouches[0].clientX - touchStart.current;
    if (diff > 60 && touchStart.current < 40) setSidebarOpen(true);   // swipe right from edge
    if (diff < -60 && sidebarOpen) setSidebarOpen(false);              // swipe left to close
    touchStart.current = null;
  }, [isMobile, sidebarOpen]);

  useEffect(() => {
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchEnd]);

  const handleNavClick = () => {
    if (isMobile) setSidebarOpen(false);
  };

  // On mobile, sidebar is an overlay (no margin shift)
  const marginLeft = isMobile ? 0 : (sidebarOpen ? 200 : 56);

  return (
    <div className="flex min-h-screen bg-[#f0f4f8] dark:bg-[#0d1117]">
      {/* Overlay — tap to close */}
      {sidebarOpen && isMobile && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Desktop overlay (non-mobile, when sidebar expands) */}
      {sidebarOpen && !isMobile && (
        <div
          className="fixed inset-0 bg-black/50 z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar
        isOpen={sidebarOpen}
        onNavClick={handleNavClick}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
      />

      <div className="flex-1 min-w-0 transition-all duration-300" style={{ marginLeft }}>
        <TopBar onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="p-4 md:p-6 lg:p-8 max-w-full overflow-hidden">{children}</main>
      </div>
      <AgentXLauncher />
    </div>
  );
};

export default AppShell;
